import { hotTopics } from "@/mocks/home";

export default function HotTopics() {
  return (
    <section className="px-4 md:px-8 py-12 md:py-16 bg-background-50 border-y border-background-200">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-2">
          <i className="ri-price-tag-3-line text-xl text-accent-600"></i>
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            热门话题标签
          </h3>
          <span className="ml-2 text-xs md:text-sm text-foreground-500">
            投稿时可参照这些标签归整线索
          </span>
        </div>

        <div className="mt-6 flex flex-wrap gap-2.5 md:gap-3">
          {hotTopics.map((topic, index) => (
            <a
              key={topic.id}
              href="#board"
              className={`flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer ${
                index % 3 === 0
                  ? "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
                  : index % 3 === 1
                    ? "bg-accent-100 text-accent-900 hover:bg-accent-200"
                    : "bg-primary-100 text-primary-800 hover:bg-primary-200"
              }`}
            >
              <span className="font-medium">{topic.label}</span>
              <span className="text-xs opacity-70">{topic.count} 条</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}